<template>
  <q-layout view="hHh LpR fFf" class="dashboard-quasar">
    <!-- Admin Sidebar -->
    <q-drawer
      v-model="sidebarVisible"
      :width="sidebarWidth"
      :breakpoint="1024"
      bordered
      content-class="dashboard-sidebar bg-dark"
      :mini="isSidebarCollapsed && !isMobile"
      @click.capture="onSidebarClick"
    >      <div class="sidebar-header q-py-md q-px-md flex items-center justify-between">        <div class="flex items-center">          <div class="text-logo">
            <q-icon name="local_offer" size="22px" class="text-amber logo-icon" :class="{'q-mr-xs': !isSidebarCollapsed || isMobile}" />
            <span v-if="!isSidebarCollapsed || isMobile" class="text-bold text-logo-text"><span class="text-amber">CouponLa</span></span>
          </div>
        </div>
        <q-btn
          v-if="!isMobile"
          flat
          round
          size="sm"
          icon="keyboard_arrow_left"
          :class="{ 'rotate-180': isSidebarCollapsed }"
          @click="toggleSidebarCollapse"
        />
      </div>      <q-list padding>
        <q-item
          clickable
          v-ripple
          :to="{ name: 'AdminDashboard' }"
          :exact="$route.path === '/admin/dashboard' || $route.path === '/admin'"
          active-class="active-menu-link"
        >
          <q-item-section avatar>
            <q-icon name="dashboard" />
          </q-item-section>
          <q-item-section>Dashboard</q-item-section>
        </q-item>        <q-item
          clickable
          v-ripple
          :to="{ name: 'AdminCoupons' }"
          active-class="active-menu-link"
        >
          <q-item-section avatar>
            <q-icon name="local_offer" />
          </q-item-section>
          <q-item-section>Coupons</q-item-section>
        </q-item>        <q-item
          clickable
          v-ripple
          :to="{ name: 'AdminStores' }"
          active-class="active-menu-link"
        >
          <q-item-section avatar>
            <q-icon name="storefront" />
          </q-item-section>
          <q-item-section>Stores</q-item-section>
        </q-item>        <q-item
          clickable
          v-ripple
          :to="{ name: 'AdminCategories' }"
          active-class="active-menu-link"
        >
          <q-item-section avatar>
            <q-icon name="category" />
          </q-item-section>
          <q-item-section>Categories</q-item-section>
        </q-item>

        <q-expansion-item
          icon="analytics"
          label="Analytics"
          :content-inset-level="isSidebarCollapsed ? 0 : 0.5"
          header-class="text-white"
        >          <q-item
            clickable
            v-ripple
            :to="{ name: 'AdminAnalytics' }"
            active-class="active-menu-link"
          >
            <q-item-section avatar>
              <q-icon name="bar_chart" />
            </q-item-section>
            <q-item-section>Overview</q-item-section>
          </q-item>

          <q-item
            clickable
            v-ripple
            to="/admin/analytics/traffic"
            active-class="active-menu-link"
          >
            <q-item-section avatar>
              <q-icon name="trending_up" />
            </q-item-section>
            <q-item-section>Traffic</q-item-section>
          </q-item>
        </q-expansion-item>        <q-item
          clickable
          v-ripple
          :to="{ name: 'AdminErrorLogs' }"
          active-class="active-menu-link"
        >
          <q-item-section avatar>
            <q-icon name="error_outline" />
          </q-item-section>
          <q-item-section>Error Logs</q-item-section>
        </q-item>
        
        <q-item
          clickable
          v-ripple
          :to="{ name: 'AdminMediaManager' }"
          active-class="active-menu-link"
        >
          <q-item-section avatar>
            <q-icon name="perm_media" />
          </q-item-section>
          <q-item-section>Media</q-item-section>
        </q-item>        <q-item          clickable
          v-ripple
          :to="{ name: 'SystemSettings' }"
          active-class="active-menu-link"
        >
          <q-item-section avatar>
            <q-icon name="settings" />
          </q-item-section>
          <q-item-section>Settings</q-item-section>
        </q-item>
          <q-item
          clickable
          v-ripple
          :to="{ name: 'DataIntegrityReport' }"
          active-class="active-menu-link"
        >
          <q-item-section avatar>
            <q-icon name="security" />
          </q-item-section>
          <q-item-section>Data Integrity</q-item-section>
        </q-item>

        <q-item
          clickable
          v-ripple
          :to="{ name: 'BannerManager' }"
          active-class="active-menu-link"
        >
          <q-item-section avatar>
            <q-icon name="view_carousel" />
          </q-item-section>
          <q-item-section>Banners</q-item-section>
        </q-item>

        <q-separator class="q-my-md" dark />

        <q-item
          clickable
          v-ripple
          @click="logout"
          active-class="active-menu-link"
        >
          <q-item-section avatar>
            <q-icon name="logout" />
          </q-item-section>
          <q-item-section>Logout</q-item-section>
        </q-item>
      </q-list>
    </q-drawer>

    <!-- Header -->
    <q-header class="bg-white text-dark" bordered>
      <q-toolbar>
        <!-- Sidebar toggle on mobile -->
        <q-btn
          v-if="isMobile"
          flat
          round
          icon="menu"
          color="primary"
          @click="sidebarVisible = !sidebarVisible"
        />        <q-toolbar-title class="flex items-center">
          <q-breadcrumbs class="text-grey-7">
            <q-breadcrumbs-el label="Admin" icon="home" :to="{ name: 'AdminDashboard' }" />
            <q-breadcrumbs-el :label="currentPage" />
          </q-breadcrumbs>
        </q-toolbar-title>

        <q-space />

        <!-- User profile dropdown -->
        <q-btn flat round>
          <q-avatar size="28px">
            <q-icon name="account_circle" size="28px" />
          </q-avatar>

          <q-menu anchor="bottom right" self="top right">
            <q-list style="min-width: 200px">
              <q-item class="q-px-md q-py-sm">
                <q-item-section>
                  <div class="text-subtitle1">{{ user?.email || 'Admin User' }}</div>
                  <div class="text-caption text-grey-7">Administrator</div>
                </q-item-section>
              </q-item>

              <q-separator />

              <q-item clickable v-ripple to="/admin/profile">
                <q-item-section avatar>
                  <q-icon name="person" size="sm" />
                </q-item-section>
                <q-item-section>Profile</q-item-section>
              </q-item>              <q-item clickable v-ripple :to="{ name: 'SystemSettings' }">
                <q-item-section avatar>
                  <q-icon name="settings" size="sm" />
                </q-item-section>
                <q-item-section>Settings</q-item-section>
              </q-item>

              <q-separator />

              <q-item clickable v-ripple @click="logout">
                <q-item-section avatar>
                  <q-icon name="logout" size="sm" />
                </q-item-section>
                <q-item-section>Logout</q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-btn>
      </q-toolbar>
    </q-header>    <!-- Main Content -->
    <q-page-container>
      <div class="container q-pa-md">
        <router-view v-if="!props.showDashboard"></router-view>
        <OverviewQuasar v-else />
      </div>
    </q-page-container>
  </q-layout>
</template>

<script setup>
import { ref, computed, onMounted, watch, defineProps } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useQuasar } from 'quasar';
import { useAuthStore } from '@/stores';
import { useResponsive } from '@/composables/useResponsive';
import OverviewQuasar from '@/views/admin/OverviewQuasar.vue';

// Define props
const props = defineProps({
  showDashboard: {
    type: Boolean,
    default: false
  }
});

// Compose utilities
const $q = useQuasar();
const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();
const { isMobile, isTablet, isDesktop } = useResponsive();

// Reactive state
const sidebarVisible = ref(!isMobile.value);
const isSidebarCollapsed = ref(false);
const user = computed(() => authStore.user);

// Responsive sidebar width
const sidebarWidth = computed(() => {
  if (isMobile.value) return 280;
  return isSidebarCollapsed.value ? 60 : 250;
});

// Current page title
const currentPage = computed(() => {
  const pathParts = route.path.split('/');
  const lastPart = pathParts[pathParts.length - 1];
  return lastPart
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
});

// Methods
const toggleSidebarCollapse = () => {
  isSidebarCollapsed.value = !isSidebarCollapsed.value;
  localStorage.setItem('admin-sidebar-collapsed', isSidebarCollapsed.value.toString());
};

const onSidebarClick = (event) => {
  // Auto collapse sidebar on mobile after navigation
  if (isMobile.value) {
    sidebarVisible.value = false;
  }
};

const logout = async () => {
  try {
    await authStore.logout();
    router.push('/admin/login');
    $q.notify({
      message: 'You have been logged out',
      color: 'positive',
      icon: 'logout',
      position: 'top',
      timeout: 2000
    });
  } catch (error) {
    console.error('Logout error:', error);
    $q.notify({
      message: 'Error logging out',
      color: 'negative',
      icon: 'error',
      position: 'top',
      timeout: 2000
    });
  }
};

// Watch for route changes
watch(() => route.fullPath, () => {
  if (isMobile.value) {
    sidebarVisible.value = false;
  }
});

// Lifecycle hooks
onMounted(() => {
  // Load sidebar state from localStorage
  const savedState = localStorage.getItem('admin-sidebar-collapsed');
  if (savedState !== null) {
    isSidebarCollapsed.value = savedState === 'true';
  }

  // Force Quasar to always use light mode for admin dashboard on mount
  if (isMobile.value && $q.dark.isActive) {
    $q.dark.set(false);
  }
});
</script>

<style lang="scss" scoped>
.dashboard-quasar {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.dashboard-sidebar {
  .sidebar-header {
    min-height: 60px;
    border-bottom: 1px solid rgba(255,255,255,0.1);
  }    .text-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
    background: linear-gradient(135deg, rgba(40, 40, 40, 0.8), rgba(20, 20, 20, 0.9));
    padding: 4px 10px;
    border-radius: 6px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3), inset 0 1px 1px rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.1);
    transition: all 0.3s ease;
    
    .logo-icon {
      filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.5));
      transform: rotate(-15deg);
      transition: all 0.3s ease;
    }
      .text-logo-text {
      font-size: 1.4rem;
      font-weight: 900;
      letter-spacing: 0.8px;
      text-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);
      transition: opacity 0.3s ease;
    }
  }
  
  .sidebar-title {
    font-size: 1.2rem;
    font-weight: 500;
    margin-left: 8px;
    transition: opacity 0.3s;
  }
}

.active-menu-link {
  color: #fff;
  background: linear-gradient(118deg, $primary, rgba($primary, 0.7));
  
  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 4px;
    background-color: $amber;
  }
}

.q-drawer-container {
  .q-drawer {
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
  }
  .q-drawer--mini {
    .sidebar-title {
      opacity: 0;
    }
    
    .text-logo {
      justify-content: center;
      padding: 4px;
      
      .logo-icon {
        margin-right: 0 !important;
        transform: rotate(-15deg) scale(1.1);
      }
    }
  }
}

.q-breadcrumbs {
  font-size: 0.9rem;
  font-weight: 500;
}

.rotate-180 {
  transform: rotate(180deg);
}

/* Transition animations */
.q-drawer-container {
  transition: all 0.3s;
}

/* Container for page content */
.container {
  max-width: 100%;
  margin: 0 auto;
  
  @media (min-width: 1200px) {
    max-width: 1140px;
  }
}
</style>
